import React, { Component } from 'react';
import * as styled from '../../styles/style';
import { userActions } from '../../actions/users';
import { Link } from 'react-router-dom';
import Notification from '../Notification';
import { history } from '../../helpers/history';

class SignIn extends Component {

	constructor(props) {
		super(props);

		const { match, authenticateWithToken } = this.props;

		if (match.params.logintoken) {
			authenticateWithToken(match.params.logintoken);
		}

		if (localStorage.getItem('auth_token')) {
			this.props.loadUserFromToken()
		}
		
		this.state = {
			email: '',
			password: ''
		}

		this.handleSubmit = this.handleSubmit.bind(this);
		this.handleChange = this.handleChange.bind(this);
	}

	componentWillUpdate(nextProps) {
	  if (nextProps.currentUser) {
      if (nextProps.currentUser.role === 'admin') {
				history.push('/host/admin/events');
			} else if (nextProps.currentUser.role === 'host') {
				history.push('/host/hub/dashboard');
			}
    }
  }

	handleChange(event) {
    this.setState({ 
    	[event.target.name]: event.target.value 
    });
  }

	handleSubmit(event) {
    event.preventDefault();
    
    let values = {
    	email: this.state.email,
    	password: this.state.password
    };

    return this.props.signInUser(values);
  }

  render() {
  	return (
      <styled.Main>
      	<Notification type={this.props.alertType} message={this.props.alertMessage} />
      	<form onSubmit={this.handleSubmit}>
          <styled.Heading>Host Sign-In</styled.Heading>
	        <styled.FormRow>
	          <styled.FullWidthFieldGroup>
	            <styled.Label htmlFor="email">Email</styled.Label>
	            <styled.FormField public id="email" type="email" name="email" value={this.state.email} onChange={this.handleChange} />
	          </styled.FullWidthFieldGroup>
	        </styled.FormRow>
	        <styled.FormRow>
	          <styled.FullWidthFieldGroup>
	            <styled.Label htmlFor="password">Password</styled.Label>
	            <styled.FormField public id="password" name="password" value={this.state.password} type="password" onChange={this.handleChange} />
	          </styled.FullWidthFieldGroup>
	        </styled.FormRow>
	        <styled.FormRow>
	        	<styled.Label>
	        		<Link to="/host/reset-password">Reset Password</Link>
	        	</styled.Label>
	        </styled.FormRow>
          <styled.Button style={{margin: '0 5px'}} type="submit" value='Sign In' />
	      </form>
      </styled.Main>
    )
  }
}

export default SignIn
